var _g, _g2, _path, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFloatingFaq = function SvgFloatingFaq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 71,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#floating_faq_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 31.5,
    r: 31.5,
    fill: "#3177FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#floating_faq_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M49.311 42.84C52.231 39.675 54 35.533 54 31c0-9.941-8.507-18-19-18s-19 8.059-19 18 8.507 18 19 18a19.8 19.8 0 0 0 7.591-1.494l8.11 3.792z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "floating_faq_svg__c",
    width: 24,
    height: 24,
    x: 23,
    y: 19,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M23 19h24v24H23z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#floating_faq_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3177FF",
    d: "M33.6 35q0-2.024.362-2.913.363-.887 1.538-1.937 1.025-.9 1.562-1.562.538-.663.538-1.513 0-1.025-.688-1.7T35 24.7q-1.275 0-1.938.775-.662.776-.937 1.575l-2.575-1.1q.524-1.6 1.925-2.775Q32.875 22 35 22q2.625 0 4.037 1.462 1.413 1.463 1.413 3.513 0 1.25-.538 2.137-.537.888-1.687 2.013-1.226 1.175-1.488 1.788-.262.612-.262 2.087zm1.4 6q-.825 0-1.413-.587A1.93 1.93 0 0 1 33 39q0-.824.587-1.413A1.93 1.93 0 0 1 35 37q.825 0 1.412.587Q37 38.176 37 39q0 .824-.588 1.413A1.93 1.93 0 0 1 35 41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "floating_faq_svg__a",
    width: 71,
    height: 71,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_742_6824"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_742_6824",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.69598 0 0 0 0 0.69598 0 0 0 0 0.69598 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_742_6824"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "floating_faq_svg__b",
    width: 40,
    height: 38.298,
    x: 14,
    y: 13,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.236516 0 0 0 0 0.450215 0 0 0 0 0.865283 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_742_6824"
  })))));
};
export default SvgFloatingFaq;